import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    monthly: {
        id: 'monthly',
        defaultMessage: 'Monthly',
    },
    weekly: {
        id: 'weekly',
        defaultMessage: 'Weekly',
    },
    daily: {
        id: 'daily',
        defaultMessage: 'Daily',
    },
});

export default enumMessages;
